import { useEffect, useRef } from "react";

type HotkeyCombo = "mod+j" | "mod+k";

/**
 * Global ⌘/Ctrl hotkey. Unlike use-keyboard-shortcuts (single bare keys,
 * skips inputs), this fires regardless of input focus — ⌘J/⌘K must work
 * while typing. Listens on window, prevents the browser default.
 */
export function useGlobalHotkey(combo: HotkeyCombo, fn: () => void): void {
  const fnRef = useRef(fn);
  fnRef.current = fn;

  useEffect(() => {
    const letter = combo.split("+")[1];
    const handler = (e: KeyboardEvent) => {
      if (
        (e.metaKey || e.ctrlKey) &&
        !e.altKey &&
        !e.shiftKey &&
        e.key.toLowerCase() === letter
      ) {
        e.preventDefault();
        fnRef.current();
      }
    };
    window.addEventListener("keydown", handler);
    return () => window.removeEventListener("keydown", handler);
  }, [combo]);
}
